import { Button, CheckList, Loading, Popup } from "antd-mobile";
import axios from "axios";
import style from "css/hotdesking.module.css";
import React, {
  useCallback,
  useEffect,
  useLayoutEffect,
  useState,
} from "react";
import HotdeskingConfig from "../Config";
import { CheckOutlined, LeftOutlined, UserOutlined } from "@ant-design/icons";
import { ReactComponent as SendIcon } from "asset/hotdesking/send.svg";
import { Avatar } from "antd";
import { useTranslation } from "react-i18next";

function ShareTeam({ book, isOpen, onClose, onError }) {
  const { t } = useTranslation();
  const [isSearch, setIsSearch] = useState(true);
  const [isLoading, setIsLoading] = useState(true);
  const [list, setList] = useState([]);
  const [checkList, setCheckList] = useState([]);
  const [departmentName, setDepartmentName] = useState("");

  const getMemberList = useCallback(() => {
    setIsLoading(true);
    const config = {
      params: {
        search_type: "department",
      },
    };
    axios
      .get(`${HotdeskingConfig.baseURI}/member`, config)
      .then((res) => {
        setList(res.data);
      })
      .finally(() => {
        setCheckList([]);
        setIsLoading(false);
      });
  }, []);

  useLayoutEffect(() => {
    if (isOpen && isSearch) {
      getMemberList();
      setIsSearch(false);
    }
  }, [getMemberList, isOpen, isSearch]);

  useEffect(() => {
    if (isOpen && list.length > 0) {
      setDepartmentName(list[0]?.department?.name);
    }
  }, [isOpen, list]);

  const onClosePopup = () => {
    setList([]);
    setCheckList([]);
    setIsSearch(true);
    onClose();
  };

  const onChange = (list) => {
    setCheckList(list);
  };

  const onShare = () => {
    setIsLoading(true);
    const data = {
      book_id: book.id,
      member_list: checkList,
    };
    axios
      .post(`${HotdeskingConfig.baseURI}/book/share`, data)
      .then(() => {
        onClosePopup();
      })
      .catch((err) => {
        onClosePopup();
        if (err === undefined || err.response === undefined) {
          onError(t("HOTDESKING.MODAL.SHARE.MESSAGE.ERROR"));
        } else {
          onError(err.response.data);
        }
      });
  };

  return (
    <Popup className={`${style.popup} ${style.share}`} visible={isOpen}>
      {isLoading ? (
        <Loading />
      ) : (
        <section className={style.list_section}>
          <section className={style.list_header}>
            <p>{t("HOTDESKING.MODAL.SHARE.MY_TEAM.TITLE")}</p>
            <LeftOutlined
              className={style.header_icon}
              onClick={onClosePopup}
            />
          </section>
          <section className={`${style.list_body} ${style.check}`}>
            <section className={`${style.content_header} ${style.team}`}>
              <p>{departmentName}</p>
              <div className={style.count_item}>{list.length}</div>
            </section>
            <CheckList
              className={style.content_body}
              onChange={onChange}
              value={checkList}
              activeIcon={<CheckOutlined className={style.active_icon} />}
              multiple
            >
              {list.map((item, idx) => (
                <CheckList.Item
                  key={idx}
                  className={
                    checkList.length > 0 &&
                    checkList.filter((id) => id === item.id).length > 0
                      ? `${style.content_item} ${style.active}`
                      : style.content_item
                  }
                  value={item.id}
                >
                  <section className={style.item_section}>
                    <Avatar
                      className={style.member_img}
                      icon={<UserOutlined className={style.member_icon} />}
                    />
                    <article className={style.member_info}>
                      <p className={style.member_name}>{item.name}</p>
                      <div className={style.member_department}>
                        <p>{item.department.name}</p>
                        <span className={style.divider} />
                        <p>{item.role}</p>
                      </div>
                    </article>
                  </section>
                </CheckList.Item>
              ))}
            </CheckList>
            <section className={style.content_footer}>
              <Button
                className={
                  checkList.length > 0
                    ? `${style.footer_button} ${style.active}`
                    : style.footer_button
                }
                disabled={checkList.length < 1}
                onClick={onShare}
              >
                <section className={style.button_section}>
                  <div className={style.check_cnt}>{checkList.length}</div>
                  <p>{t("HOTDESKING.BUTTON.SEND")}</p>
                  <SendIcon />
                </section>
              </Button>
            </section>
          </section>
        </section>
      )}
    </Popup>
  );
}

export default ShareTeam;
